/**
 * Förderabzug (z. B. EGZ).
 * Produktive Fachkräfte: nur am Schluss vom Sollumsatz, Teamlohn und Gemeinkosten bleiben voll.
 * Azubis und produktive Fachkräfte: nur am Schluss vom Sollumsatz. Team-Stundenlohn bleibt voll.
 * Unproduktive: der Satz wird vollständig aus den Gemeinkosten gezogen.
 */

const bruttoUngekuerzt = (m: any): number => {
  const raw = Number(
    m?.grundgehalt ?? m?.grundgehaltBrutto ?? m?.brutto ?? m?.bruttoGehaltMonat ?? 0
  );
  return Number.isFinite(raw) ? Math.max(0, raw) : 0;
};

export const foerderzuschussEinesMitarbeiters = (m: any): number => {
  if (!m || m.isGefoerdert !== true) return 0;
  const brutto = bruttoUngekuerzt(m);
  if (m.foerderArt === 'euro') {
    const euro = Number(m.foerderEuro);
    if (!Number.isFinite(euro) || euro <= 0) return 0;
    return brutto > 0 ? Math.min(euro, brutto) : euro;
  }
  const quoteRaw = Number(m.foerderquoteProzent);
  const quote = Number.isFinite(quoteRaw) && quoteRaw > 0 ? Math.min(100, quoteRaw) : 50;
  return brutto * (quote / 100);
};

/** 0..1. Euro-Betrag wird am Brutto gedeckelt. */
export const foerderSatz = (m: any): number => {
  if (!m || m.isGefoerdert !== true) return 0;
  const brutto = bruttoUngekuerzt(m);
  if (m.foerderArt === 'euro') {
    const euro = Number(m.foerderEuro);
    if (!Number.isFinite(euro) || euro <= 0) return 0;
    if (brutto <= 0) return 1;
    return Math.min(1, euro / brutto);
  }
  const quoteRaw = Number(m.foerderquoteProzent);
  const quote = Number.isFinite(quoteRaw) && quoteRaw > 0 ? Math.min(100, quoteRaw) : 50;
  return quote / 100;
};

export const summeNeutralerFoerderzuschuss = (mitarbeiter: any[]): number => {
  return (mitarbeiter || []).reduce(
    (sum, m) => sum + foerderzuschussEinesMitarbeiters(m),
    0
  );
};
